import { Button, MagellanPopup } from 'components/atoms';
import { ReactNode, useRef } from 'react';
import { Trans, useTranslation } from 'react-i18next';
import { PiInfo } from 'react-icons/pi';
import Popup from 'reactjs-popup';
import { PopupActions } from 'reactjs-popup/dist/types';
import { BUTTON_VARIANT } from 'types/components/button/button.interface';
import { IChildrenProp } from 'types/components/components.interface';
import './ViewHint.scss';

interface IViewHintProps extends IChildrenProp {
  title?: ReactNode;
  hintId?: string;
  descriptionValues?: any;
  descriptionComponents?: any;
}

const ViewHint = ({
  title,
  children,
  hintId,
  descriptionValues,
  descriptionComponents,
}: IViewHintProps) => {
  const popupRef = useRef<PopupActions>(null);
  const { t } = useTranslation();
  // const { hints, defaultHint, setHint } = useStoreState();

  return (
    <Popup
      ref={popupRef}
      modal
      nested
      trigger={
        <div className="view-hint">
          <div className="view-hint-header">
            <Button isClear onlyIcon>
              <Button.Icon icon={<PiInfo />} />
              <Button.Description description={t('button.hint')} />
            </Button>
            <div className="view-hint-header-title">
              {hintId && t(`hint.${hintId}.title`)} {title}
            </div>
          </div>
        </div>
      }
    >
      <MagellanPopup>
        <MagellanPopup.Header>
          <PiInfo /> {t('button.hint')}
        </MagellanPopup.Header>
        <div className="view-hint-popup">
          <div className="view-hint-popup-header"> {hintId && t(`hint.${hintId}.title`)}</div>
          <div className="view-hint-popup-content">
            {hintId && (
              <Trans
                i18nKey={`hint.${hintId}.description`}
                values={descriptionValues}
                components={descriptionComponents}
              />
            )}
            {children}
          </div>
        </div>
        <MagellanPopup.BottomButtons>
          <Button
            variant={BUTTON_VARIANT.background}
            fullWidth
            onClick={() => popupRef.current?.close()}
          >
            <Button.Text text={t('button.close')} />
          </Button>
        </MagellanPopup.BottomButtons>
      </MagellanPopup>
    </Popup>
  );
};

export default ViewHint;
